import React, { useState } from "react";
import { View, TouchableOpacity } from "react-native";
import Image from "@components/common/Image";
import Text from "@components/AppText";
import { normalize } from "@utils/metrics";
import EditIcon from "@assets/svg/Profile/EditIcon";
import Caution from "@assets/svg/Profile/Caution";
import TickRound from "@assets/svg/Profile/TickRound";
import { useNavigation } from "@react-navigation/native";
import {
  PROFILE_EVENTS,
  PROFILE_EVENT_SOURCES,
} from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
import { useSelector } from "react-redux";
import Progress from "./Progress";
import testIds from "@constants/testIds";

const HeaderSection = () => {
  const {
    name,
    user_image,
    phone_number,
    clDropDownOptions = [],
    ...userDetails
  } = useSelector(({ auth: { user } }) => user);
  const navigation = useNavigation();
  const [userImage, setUserImage] = useState(
    "https://storage.googleapis.com/cm-catalogue-images/1590762913152male_avatar.webp",
  );

  const getInitialData = () => {
    let initialData = {};
    clDropDownOptions.forEach((el, i) => {
      initialData = Object.assign(initialData, {
        [el.name]: userDetails[el.name],
      });
    });
    return initialData;
  };

  const getItems = () => {
    const items = [];
    const initialdata = getInitialData();
    clDropDownOptions.map((option) => {
      if (option.is_skipable) {
        return;
      }
      if (!option.show_profile) return;
      if (initialdata[option.name] !== null) return;
      const method = "push";
      items[method](option);
    });
    return items;
  };

  const totalItems = getItems();
  const totalItemsForPercent = clDropDownOptions.filter((elem) => {
    return !elem.is_skipable && elem.show_profile;
  });
  const completed = totalItemsForPercent.length - totalItems.length;
  const percentage = Math.floor(
    (completed / totalItemsForPercent.length) * 100,
  );

  return (
    <View>
      <View style={{ alignItems: "center", marginBottom: 15 }}>
        <Progress
          allowEmpty={true}
          percentage={Number.isNaN(percentage) ? 0 : percentage}
        >
          <ProfilePicture uri={user_image || userImage} />
          <TouchableOpacity
            testID={testIds.edit_profile_btn}
            onPress={() => {
              navigation.navigate("EditProfile", {
                edit_type: "Profile Picture",
              });
              analytics.trackEvent(PROFILE_EVENTS.PROFILE_EDIT, {
                section: PROFILE_EVENT_SOURCES.PRIMARY,
              });
            }}
            style={{
              backgroundColor: "white",
              padding: 15,
              borderRadius: 200,
              position: "absolute",
              bottom: 35,
              right: 10,
              borderWidth: 0.5,
              borderColor: "rgba(0, 0, 0, 0.36)",
            }}
          >
            <View>
              <EditIcon />
            </View>
          </TouchableOpacity>
          <View
            style={{
              backgroundColor: "white",
              padding: 5,
              borderRadius: 40,
              position: "absolute",
              bottom: 0,
              borderWidth: 1,
              borderColor: percentage === 100 ? "#00AB59" : "#F25700",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {percentage === 100 ? <TickRound /> : <Caution />}
            <Text style={{ marginLeft: 4 }}>{`${percentage} %`}</Text>
          </View>
        </Progress>
      </View>
    </View>
  );
};

export default HeaderSection;

const ProfilePicture = ({ uri }) => {
  return (
    <View
      testID={testIds.profile_picture}
      style={{
        width: normalize(100),
        height: normalize(100),
        borderRadius: 100,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <View
        style={{
          width: normalize(120),
          height: normalize(120),
          borderRadius: 100,
          // borderWidth: 1,
          // borderColor: "rgba(0,0,0,0.7)",
          marginVertical: normalize(30),
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View
          style={{
            width: normalize(110),
            height: normalize(110),
            borderRadius: 100,
            // backgroundColor: "blue",
            marginVertical: normalize(30),
          }}
        >
          <Image
            source={{ uri }}
            resizeMode={Image.resizeMode.cover}
            style={{
              width: normalize(110),
              height: normalize(110),
              borderRadius: 100,
            }}
          />
        </View>
      </View>
    </View>
  );
};
